export const profile = {
  myProfile: "ملفي الشخصي",
  personalInfo: "المعلومات الشخصية",
  name: "الاسم",
  phone: "رقم الجوال",
  email: "البريد الإلكتروني",
  editProfile: "تعديل الملف الشخصي",
  changePassword: "تغيير كلمة المرور",
  privacySettings: "إعدادات الخصوصية",
  notificationSettings: "إعدادات الإشعارات",
  language: "اللغة",
  subscriptionInfo: "معلومات الاشتراك",
  searchHistory: "سجل البحث",
  support: "الدعم",
  faq: "الأسئلة الشائعة",
  contactUs: "تواصل معنا",
  logout: "تسجيل الخروج",
  deleteAccount: "حذف الحساب",
  version: "الإصدار"
};